<ng-template #additionalInfoTemplate><ng-content select="[projectedAdditionalInfo]"></ng-content></ng-template>

<mat-table class="mat-elevation-z4" [dataSource]="this.AllModesDataSource">
  <!-- Define the grid's column definitions. -->
  @for (hshColumnDef of this.GridColumnDefs; track hshColumnDef; let iColIndex = $index) {
    <ng-container matColumnDef="{{hshColumnDef.name}}">
      <!-- Define each grid field's/column's header area. -->
      <mat-header-cell class="min-width-250" *matHeaderCellDef (contextmenu)="this.gridColumnContextMenuClick($event,hshColumnDef)">
        <ng-container>
          <mat-select [(ngModel)]="hshColumnDef.fieldDefinitionClassName"
            (selectionChange)="this.handleFieldDefinitionChange()"
            title="{{this.getFieldTypeTitle(hshColumnDef)}}"
            class="column-data-type-select">
            <mat-select-trigger>
              @if (this.getColumnTypeIconType(hshColumnDef) == 'MatIcon') {
                <mat-icon>{{this.getColumnTypeIconName(hshColumnDef)}}</mat-icon>
              }
              @if (this.getColumnTypeIconType(hshColumnDef) == 'SvgIcon') {
                <mat-icon svgIcon="{{this.getColumnTypeIconName(hshColumnDef)}}"></mat-icon>
              }
            </mat-select-trigger>
            @for (hshFieldTypeAndName of this.FieldTypesAndNames; track hshFieldTypeAndName) {
              <mat-option
                [value]="hshFieldTypeAndName.fieldType"
                title="{{hshFieldTypeAndName.fieldName}}">
                @if (hshFieldTypeAndName.iconType == 'MatIcon') {
                  <mat-icon>{{hshFieldTypeAndName.IconName}}</mat-icon>
                }
                @if (hshFieldTypeAndName.iconType == 'SvgIcon') {
                  <mat-icon svgIcon="{{hshFieldTypeAndName.IconName}}"></mat-icon>
                }
                <span>{{hshFieldTypeAndName.fieldName}}</span>
              </mat-option>
            }
          </mat-select>
          <div class="column-header-column-name-div">
            <p class="design-column-name-p"
              matTooltip="{{this.getColumnTooltip(iColIndex,hshColumnDef)}}"
            [matTooltipPosition]="this.TooltipPosition">{{hshColumnDef.displayName}}</p>
          </div>
        </ng-container>
      </mat-header-cell>
      <!-- Define each grid field's/column's content area. -->
      <mat-cell class="min-width-250" *matCellDef="let gridRow">
        <div class="column-preview-div"
          (contextmenu)="this.gridColumnContextMenuClick($event,hshColumnDef)">
          <!--Used for both attachment and regular grid-->
          <div class="column-preview-form-field-wrapper-div">
            <app-form-field-wrapper [formField]="hshColumnDef"
              [mode]="'gridDesign'"
              [fieldIsInGrid]="true"
              [displayHints]="this.FormFieldDisplayHints"
              (onInit)="this.gridColumnInit($event,hshColumnDef)"
              (onEdit)="this.gridColumnEdit($event,hshColumnDef)"
              (dblclick)="this.onCellDoubleClick(hshColumnDef)"
              (onPropertyUpdated)="this.handleOnPropertyUpdated($event)"
              (onContextMenuClick)="this.gridColumnContextMenuClick($event,hshColumnDef)">
            </app-form-field-wrapper>
          </div>
          <div class="consume-vertical-space-div"></div>
          @if (this.displayDeleteIconForColumn(hshColumnDef)) {
            <button mat-stroked-button
              class="remove-column-button"
              title="Remove column"
              aria-label="Remove column"
              (click)="this.removeGridColumnClicked(hshColumnDef)"
              (contextmenu)="this.gridColumnContextMenuClick($event,hshColumnDef)">
              <mat-icon svgIcon="trash" class="delete-column-trash-mat-icon"></mat-icon>
            </button>
          }
        </div>
      </mat-cell>
      <!--
      Display a zero/'0' preview value for numeric columns/form fields
      and a blank/'' for non-numeric columns/form fields.
      -->
      <mat-footer-cell class="min-width-250" *matFooterCellDef>
        {{this.getNumericTotalPreviewValue(iColIndex,hshColumnDef)}}
      </mat-footer-cell>
    </ng-container>
  }

  <!-- Define an add grid column definition. -->
  @if (! this.ReadOnly) {
    <ng-container
      matColumnDef="Add Grid Column">
      <mat-header-cell class="min-width-250" *matHeaderCellDef>
        <div class="add-grid-column-mat-icon-div">
          <mat-icon aria-hidden="false"
            aria-label="Add grid column"
          (click)="this.addGridColumnClicked()">add</mat-icon>
        </div>
        <div class="add-grid-column-mat-icon-div">
          <div aria-hidden="false"
            aria-label="Reorder Columns"
          (click)="this.reorderColumnsClicked()">Reorder Columns</div>
        </div>
        <!-- Render any additional info that the parent component (e.g. AttachmentsFormFieldComponent) wants to display -->
        <ng-container *ngTemplateOutlet="additionalInfoTemplate"></ng-container>
      </mat-header-cell>
      <mat-cell class="min-width-250" *matCellDef="let gridRow">
        <div class="add-grid-column-mat-cell-div"
          droppable
          [dropScope]="'gridField'"
          (onDrop)="this.onFieldDropped($event)">
          <p class="add-grid-column-guidance-p">Drag a field here ...</p>
        </div>
      </mat-cell>
      <!-- Display a 'Totals' label in the following footer cell. -->
      <mat-footer-cell class="min-width-250" *matFooterCellDef>
        <span class="numeric-column-totals-label">Totals</span>
      </mat-footer-cell>
    </ng-container>
  }

  <!-- Define the grid's row header. -->
  <mat-header-row *matHeaderRowDef="this.GridColumnNames(! this.ReadOnly)"></mat-header-row>

  <!-- Define the grid's row data. -->
  <mat-row *matRowDef="let row; columns: GridColumnNames(! this.ReadOnly)"></mat-row>

  <!-- Has FormField.showFooter been checked? -->
  <mat-footer-row *matFooterRowDef="this.GridColumnNames(! this.ReadOnly)"
  [ngClass]="this.ShowNumericTotalsFooter ? 'shown-preview-mat-footer-row' : 'hidden-preview-mat-footer-row'"></mat-footer-row>
</mat-table>
